import React, { useState, useEffect } from 'react';
import * as R from 'ramda';
import { composePS } from '@cd/pipe';
import { useHistory, useLocation } from 'react-router';
import styles from '../css/Register.module.scss';
import { postJSONPS } from '../../lib/utils/fetch';
import { either } from '../../lib/utils/utils';
import Form from '../../dynamic/components/form/components/Form';
import { RESET_PWD_FORM } from '../../lib/utils/formFields';
import { useForm } from '../../dynamic/components/form/components/formUtils';
import withAlert from './withAlert';

const postVerifyToken = token =>
	composePS(postJSONPS)('POST', `/resetPassword/verify`, {
		body: JSON.stringify({ data: { token } })
	});

const postResetPassword = (token, password) =>
	composePS(postJSONPS)('POST', `/resetPassword`, {
		body: JSON.stringify({ data: { token, password } })
	});

const errorMessage = e => (R.is(String, e) ? e : JSON.stringify(e));

// Landing page for the emailed link: /reset-password?token=...
// The token is read once and then dropped from the address bar / history so
// it does not linger in the browser or leak through the Referer header.
const ResetPassword = withAlert(({ onOpenAlertDlg }) => {
	const history = useHistory();
	const location = useLocation();
	const [token] = useState(
		() => new URLSearchParams(location.search).get('token') || ''
	);
	const [linkOk, setLinkOk] = useState(false);
	const {
		data,
		onUpdateData,
		showPassword,
		onShowPassword,
		onSave: formOnSave,
		touched,
		validation,
		updateInitData
	} = useForm({ joiValidationSchema: RESET_PWD_FORM });

	const onRequestNewLink = () => {
		history.push('/forgotPassword');
	};

	useEffect(() => {
		if (location.search) {
			history.replace('/reset-password');
		}
		updateInitData({ password: '', confirmPassword: '' });
		postVerifyToken(token).then(
			either(
				e =>
					onOpenAlertDlg({
						message: errorMessage(e),
						title: 'Reset Link',
						okCallback: onRequestNewLink
					}),
				() => setLinkOk(true)
			)
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onSave = () => {
		postResetPassword(token, data.password).then(
			either(
				e =>
					onOpenAlertDlg({
						message: errorMessage(e),
						title: 'Error'
					}),
				message => {
					formOnSave();
					onOpenAlertDlg({
						message,
						title: 'Success',
						okCallback: () => {
							history.push('/login');
						}
					});
				}
			)
		);
	};

	if (!linkOk) {
		return null;
	}

	return (
		<div className={styles.wrap} style={{ marginTop: '128px' }}>
			<Form
				alwaysTouched
				formTitle="SET NEW PASSWORD"
				formFields={RESET_PWD_FORM}
				data={data}
				onUpdateData={onUpdateData}
				showPassword={showPassword}
				onShowPassword={onShowPassword}
				onSave={onSave}
				onCancel={onRequestNewLink}
				validation={validation}
				editing={true}
				touched={touched}
				buttonLabels={['RESET PASSWORD', 'NEW LINK']}
				buttonIcons={['lock', 'keyboard_backspace']}
			/>
		</div>
	);
});

export default ResetPassword;
